<script>
  // A live countdown to a coming-soon product's launch. At zero it fetches the store again so the product goes on sale on screen.
  //   compact: one line for product cards ("2D 04:12:09").  Otherwise: day / hour / minute / second blocks for the product page.
  import { onMount } from 'svelte';
  import { now, remaining, launchReached, watchLaunches } from '../lib/clock.js';

  let { to, compact = false, label = 'Drops in' } = $props();

  const left = $derived(remaining(to, $now));
  const pad = (n) => String(n).padStart(2, '0');
  let fired = false;
  $effect(() => { if (left.ms === 0 && !fired) { fired = true; launchReached(); } });
  onMount(() => watchLaunches());

  const units = $derived([
    ...(left.days ? [{ v: left.days, l: left.days === 1 ? 'Day' : 'Days' }] : []),
    { v: pad(left.hours), l: 'Hrs' }, { v: pad(left.minutes), l: 'Min' }, { v: pad(left.seconds), l: 'Sec' },
  ]);
  // Read out at most once a minute, not every second.
  const spoken = $derived(left.ms === 0 ? 'On sale now' : `${label} ${left.days ? `${left.days} day${left.days === 1 ? '' : 's'}, ` : ''}${left.hours} hours and ${left.minutes} minutes`);
</script>

{#if compact}
  <span class="tabular-nums" aria-label={spoken}>
    {#if left.ms === 0}ON SALE NOW{:else}{label.toUpperCase()} {left.days ? `${left.days}D ` : ''}{pad(left.hours)}:{pad(left.minutes)}:{pad(left.seconds)}{/if}
  </span>
{:else}
  <div>
    <p class="text-label tracking-[0.2em] text-muted-foreground mb-2">{left.ms === 0 ? 'ON SALE NOW' : label.toUpperCase()}</p>
    {#if left.ms > 0}
      <div class="flex gap-2" aria-hidden="true">
        {#each units as u (u.l)}
          <div class="min-w-[4rem] border border-border px-3 py-2 text-center">
            <span class="block text-2xl font-display font-bold tabular-nums leading-none">{u.v}</span>
            <span class="mt-1 block text-[10px] tracking-[0.2em] uppercase text-muted-foreground">{u.l}</span>
          </div>
        {/each}
      </div>
      <p class="sr-only" aria-live="polite">{spoken}</p>
    {:else}
      <p class="text-sm text-muted-foreground" role="status">Getting it ready for you…</p>
    {/if}
  </div>
{/if}
